import React from 'react';
import { WorkplaceHealthPlansQuery } from '../../../../graphql/graphql';
// @ts-ignore
import styles from './WorkplaceHealthPlans.module.scss';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';

interface Props {
	openCaseTypes: (healthPlanCode: HealthPlanCode) => void;
	data: WorkplaceHealthPlansQuery;
}

const WorkplaceHealthPlans: React.FC<Props> = ({ openCaseTypes, data }) => {
	const handleOpenCaseTypes = async (healthPlanCode: string) => {
		openCaseTypes(healthPlanCode as HealthPlanCode);
	};

	return (
		<div className={styles.wrapper}>
			{data?.workplaceHealthPlans?.data?.map(item => (
				<div className={styles.item}>
					<div className={styles.title}>
						<div>{item?.name}</div>
						{item?.code && (
							<Button
								title='base.caseTypes'
								theme={Theme.BLUE}
								onClick={() => handleOpenCaseTypes(item.code as string)}
							/>
						)}
					</div>
				</div>
			))}
		</div>
	);
};

export default WorkplaceHealthPlans;
